import React from 'react';

const SubmitButton = () => (
  <button
    type="submit"
    className="gcc-btn gcc-btn-primary w-100 pa3 bw0 white mv2"
    id="submit-button"
  >
    Submit
  </button>
);

export default SubmitButton;
